import { html } from 'lit';
import { CircleArrowDown } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-circle-arrow-down')
export class PdsIconCircleArrowDown extends PdsIcon {
  @state()
  icon = CircleArrowDown;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
